// extracted by mini-css-extract-plugin
export default {"error":"error--r0AIV"};